export const isDevEnvironment = import.meta.env.DEV

const DEV_TITLE_PREFIX = '🚧 [DEV] '
const LEGACY_DEV_TITLE_PREFIX = '🔧 [DEV] '
const DEV_BADGE_DISMISSED_KEY = 'gamification.devEnvironment.badge.dismissed'

export function stripDevTitlePrefix(title: string): string {
  if (title.startsWith(DEV_TITLE_PREFIX)) {
    return title.slice(DEV_TITLE_PREFIX.length)
  }
  if (title.startsWith(LEGACY_DEV_TITLE_PREFIX)) {
    return title.slice(LEGACY_DEV_TITLE_PREFIX.length)
  }
  return title
}

/** Prefixes document titles in local dev so browser tabs are easy to spot. */
export function applyDevDocumentTitle(title: string): string {
  if (!isDevEnvironment || !title) return title
  return `${DEV_TITLE_PREFIX}${stripDevTitlePrefix(title)}`
}

export function isDevBadgeDismissed(): boolean {
  if (typeof window === 'undefined') return false
  return window.sessionStorage.getItem(DEV_BADGE_DISMISSED_KEY) === '1'
}

export function dismissDevBadge(): void {
  window.sessionStorage.setItem(DEV_BADGE_DISMISSED_KEY, '1')
}
